<template>
  <div class="map-column">
    <div class="map-wrapper">
      <div
        class="map-element-container"
        :class="{'-tall': tall}"
      >
        <div class="pro-tag">
          PRO +
        </div>
        <div
          class="map"
          ref="map"
        />
      </div>
      <div class="info-windows">
        <info-window-content
          v-for="business in businesses"
          :key="business.id + cityId"
          :business="business"
          ref="infoWindowsContent"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { loadGoogleMapsScript } from '../../../../utils/googleMaps'
import agencyPin from '../../../../../images/agency-pin.png'
import agencyPinPro from '../../../../../images/agency-pin-pro.png'
import userPin from '../../../../../images/user-pin.png'
import InfoWindowContent from '../InfoWindowContent'

export default {
  name: 'BusinessesMap',
  components: {
    InfoWindowContent,
  },
  props: {
    businesses: {
      type: Array,
      default: () => [],
    },
    zoom: {
      type: Number,
      default: 10,
    },
    customMapCenter: {
      type: Object,
      default: () => null,
    },
    hideUserLocationMarker: {
      type: Boolean,
      default: false,
    },
    tall: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.$store.dispatch('ui/LOAD_GOOGLE_MAPS_SCRIPT', this.initMap)
  },
  watch: {
    cityId() {
      if (this.map) {
        this.restartMap()
      }
    },
    userCoords: {
      deep: true,
      handler(val) {
        if (!val) {
          return
        }
        this.updateUserLocation()
      },
    },
  },
  data() {
    return {
      map: undefined,
      infoWindows: [],
      userMarker: undefined,
    }
  },
  computed: {
    googleMapsExists() {
      return this.$store.state.ui.googleMapsExists
    },
    mapCenter() {
      if (this.customMapCenter) {
        return this.customMapCenter
      }
      return { lat: this.businesses[0].city.latitude, lng: this.businesses[0].city.longitude }
    },
    cityId() {
      return this.businesses[0].city.id
    },
    userPosition() {
      const coords = this.$store.state.businessSearch.userCoords
      if (!coords) {
        return false
      }

      return { lat: coords.latitude, lng: coords.longitude }
    },
  },
  methods: {
    loadGoogleMapsScript,
    initMap() {
      this.$nextTick(() => {
        this.map = new window.google.maps.Map(this.$refs.map, {
          center: this.mapCenter,
          zoom: this.zoom,
          mapTypeControl: false,
        })
        this.addUserLocationMarker()
        this.addBusinessesMarkers()
        this.$store.dispatch('businessSearch/UPDATE_MAP_MARKER_ICONS')
      })
    },
    restartMap() {
      this.destroyMap()
      this.initMap()
    },
    destroyMap() {
      this.$store.commit('businessSearch/CLEAR_MARKERS')
      this.map = undefined
      this.infoWindows = []
    },
    addUserLocationMarker() {
      if (this.hideUserLocationMarker) {
        return
      }
      this.userMarker = new window.google.maps.Marker({
        position: this.userPosition || this.mapCenter,
        map: this.map,
        icon: userPin,
      })
    },
    addBusinessesMarkers() {
      this.businesses.forEach((business, index) => {
        const pinIcon = business.is_pro_plus ? agencyPinPro : agencyPin
        const marker = new window.google.maps.Marker({
          position: new window.google.maps.LatLng(business.latitude, business.longitude),
          map: this.map,
          icon: pinIcon,
          rentBusinessId: business.id,
          rentPro: business.is_pro_plus,
        })

        const infoWIndow = new window.google.maps.InfoWindow({
          content: this.$refs.infoWindowsContent[index].$el,
        })

        this.infoWindows.push(infoWIndow)

        marker.addListener('click', () => {
          this.infoWindows.forEach((iw) => iw.close())
          infoWIndow.open(this.map, marker)
        })

        this.$store.commit('businessSearch/ADD_MARKER', marker)
      })
    },
    updateUserLocation() {
      if (!this.userPosition) {
        return
      }
      this.userMarker.setPosition(this.userPosition)
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../../../../../sass/config/vars";
@import "../../../../../sass/config/mixins";
@import "../../../../../sass/config/responsive";

.map-column {
  align-self: stretch;
  position: relative;
}

.map-wrapper {
  position: relative;
}

.map-element-container {
  border: 1px solid $desert-storm;
  display: block;
  height: 582px;
  padding: 15px;
  position: relative;
  width: 100%;

  &.-tall {
    height: 650px;
  }
}

.map {
  height: 65vh;
  margin: 0 0 20px;

  @include teq-breakpoint($large) {
    height: 100%;
    max-height: 550px;
    position: sticky;
    top: 0;

    .-tall & {
      max-height: 650px;
    }
  }
}

.map {
  height: 100%;
}

.info-windows > * {
  display: none;
}

.pro-tag {
  background: #fff;
  color: #201906;
  font-size: 11px;
  left: 30px;
  line-height: 1;
  padding: 10px 20px;
  //css code copied from old map
  position: absolute;
  text-align: center;
  top: 30px;
  z-index: 1;

  &::after,
  &::before {
    border: 8px solid #333;
    border-bottom-color: transparent;
    border-left-color: transparent;
    content: "";
    height: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 0;
  }

  &::after {
    border: none;
    color: #fff;
    content: "+";
    height: 5px;
    line-height: 1;
    right: 3px;
    width: 5px;
  }
}
</style>
